import React, { useState } from "react";
import '../../styles/InputForm.css';  
const InputForm = () => {
  const [name, setName] = useState("");
  const [grade, setGrade] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState({ name: false, grade: false, phone: false });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState("");

  const validateName = (value) => /^[a-zA-Z]+( [a-zA-Z]+)*$/.test(value.trim());
  const validatePhone = (value) => /^[0-9]{10}$/.test(value);

  const handleGradeChange = (e) => {
    setGrade(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      grade: false,
    }));
  };

  const handleNameChange = (e) => {
    const nameValue = e.target.value;
    if (nameValue === '' || /^[a-zA-Z ]*$/.test(nameValue)) {
        setName(nameValue);
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: false,
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: true,
      }));
    }
  };

  const handlePhoneChange = (e) => {
    const phoneValue = e.target.value;
    if (/^\d{0,10}$/.test(phoneValue)) {
      setPhone(phoneValue);
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: false,
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: true,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setApiError("");

    const nameError = !validateName(name);
    const gradeError = grade === "";
    const phoneError = !validatePhone(phone);
    setErrors({ name: nameError, grade: gradeError, phone: phoneError });

    if (!nameError && !gradeError && !phoneError) {
      const urlParams = new URLSearchParams(window.location.search);
      const meetLink = urlParams.get("meetLink");
      const schoolCode = urlParams.get("schoolCode");
      const fees = urlParams.get("fees")
      const actual_source_url = window.location.href?.slice(0,190)
      
      if (!meetLink) {
        setApiError("Meeting link not found. Please Contact admin.");
        return;
      }

      setIsSubmitting(true);

      try {
        const requestBody = {
          Name: name.trim(),
          Phone: parseInt(phone),
          MeetLink: meetLink,
          Grade: parseInt(grade),
          SchoolCode: schoolCode,
          Fees: fees,
          ActualSourceUrl: actual_source_url
        };

        const response = await fetch('https://lsqservice.devinfinitylearn.in/api/v1/webinar/join', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody)
        });
        
        const responseData = await response.json();

        if (!response.ok) {
          throw new Error(responseData.message || 'Failed to join webinar');
        }

        window.location.href = meetLink;
      } catch (error) {
        console.error('Error details:', {
          message: error.message,
          stack: error.stack
        });
        
        setApiError(error.message || 'Failed to join webinar. Please try again.');
        setIsSubmitting(false);
      } 
    }
  };

  return (
    <form onSubmit={handleSubmit} className="container">
      <h2 className="title">Enter Your Details to Join</h2>
      
      {apiError && (
        <div className="errorMessage formGroup">
          {apiError}
        </div>
      )}
      
      <div className="formGroup">
        <label htmlFor="name" className="label">Name</label>
        <input
          id="name"
          type="text"
          value={name}
          onChange={handleNameChange}
          placeholder="Enter your name"
          className={`input ${errors.name ? 'errorInput' : ''}`}
        />
        {errors.name && 
          <p className="error">Please enter a valid name (letters only).</p>
        }
      </div>

      <div className="formGroup">
        <label htmlFor="grade" className="label">Grade</label>
        <select
          id="grade"
          value={grade}
          onChange={handleGradeChange}
          className={`select ${errors.grade ? 'errorInput' : ''}`}
        >
          <option value="">Select your grade</option>
          {[...Array(12).keys()].map((i) => (
            <option key={i + 1} value={i + 1}>
              Grade {i + 1}
            </option>
          ))}
        </select>
        {errors.grade && 
          <p className="error">Please select a valid grade.</p>
        }
      </div>

      <div className="formGroup">
        <label htmlFor="phone" className="label">Phone Number</label>
        <input
          id="phone"
          type="text"
          value={phone}
          onChange={handlePhoneChange}
          placeholder="Enter your phone number"
          maxLength={10}
          className={`input ${errors.phone ? 'errorInput' : ''}`}
        />
        {errors.phone && 
          <p className="error">Please enter a valid 10-digit phone number.</p>
        }
      </div>

      <button 
        type="submit" 
        className="button"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Joining...' : 'Start Webinar'}
      </button>
    </form>
  );
};

export default InputForm;